'use client';
import * as echarts from 'echarts';

export const xAxis: echarts.EChartsOption['xAxis'] = {
  type: 'category',
} as echarts.XAXisComponentOption;

export const yAxis: echarts.EChartsOption['yAxis'] = {
  type: 'value',
  splitLine: {
    show: true,
  },
} as echarts.YAXisComponentOption;

export const grid: echarts.EChartsOption['grid'] = {
  left: 0,
  right: 0,
  top: 50,
  bottom: 10,
};

export const legend: echarts.EChartsOption['legend'] = {
  show: true,

  textStyle: {
    color: '#B7B9BC',
    fontSize: 12,
  },
  icon: 'circle',
  itemWidth: 6,
  itemHeight: 6,
  itemGap: 16,
  left: 0,
  top: 0,
};

export const tooltip: echarts.EChartsOption['tooltip'] = {
  trigger: 'axis',
  backgroundColor: 'rgba(39, 39, 39, 0.9)',
  borderColor: '#4D4D4D',
  textStyle: { color: '#fff' },
};

export const BaseChartOptions = {
  animation: true,
  animationDuration: 300,
};

export const ECHARTS_DEFAULT_COLORS = [
  '#5470c6',
  '#91cc75',
  '#fac858',
  '#ee6666',
  '#73c0de',
  '#3ba272',
  '#fc8452',
  '#9a60b4',
  '#ea7ccc',
];
